// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RecipientAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import AddUserPopup from 'modules/User/Izenda.AddUserPopup';
import ACCESS_CONSTANT from 'logic/data/Izenda.AccessConstants';
import { curry, split } from 'lodash/fp';

export default withHandlers({
  openPopupAddUserPopup,
  addRecipients: curry(addRecipients),
  onAddNewSelect
});

/**
 * Open add user popup
 * @param  {Object} props props
 */
function openPopupAddUserPopup(props: any) {
  return () => {
    const recipients = props.data.recipients;
    props.openPopup(AddUserPopup, {
      onChange: props.data.addMoreRecipients.bind(props.data),
      userModeType: ACCESS_CONSTANT.USER_ACCESS_MODE.SCHEDULE,
      validateEmails: true,
      selectedItems: recipients ? split(';', recipients).map(item => ({ email: item })) : []
    });
  };
}

/**
 * Validate new email
 * @param  {Object} props props
 */
function onAddNewSelect(props: any) {
  return () => {
    const { authorization } = props;
    const permissionKeys = props.authorizationConstants.PERMISSION_KEY;
    return authorization.checkPrivileges([permissionKeys.SchedulingSchedulingScopeExternalUsers]);
  };
}

/**
 * Add new email
 * @param  {Object} add recipients
 * @param  {Array<any>} userAccountList user
 */
function addRecipients(props: any, userAccountList: Array<any>) {
  props.data.addRecipients(userAccountList);
}



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.RecipientAction.js